import { cn } from "@gymflow/helpers";
import { Button } from "apps/portal/src/components/atoms";
import { ReactNode } from "react";

type StatusColorClass = {
  iconClassName: string;
  textClassName: string;
};

export type StatusRowProps = {
  icon: ReactNode;
  colorClass: StatusColorClass;
  title: string;
  subtitle?: string;
  actionButton?: {
    label: string;
    icon: ReactNode;
    onClick: () => Promise<void> | void;
  };
};

export const StatusRow = ({
  icon,
  colorClass,
  title,
  subtitle,
  actionButton,
}: StatusRowProps) => {
  return (
    <div className="flex justify-between border-b border-b-gray-300 py-2 pl-3 pr-2 dark:border-gray-700">
      <div className="flex items-center justify-start gap-2">
        <div
          className={cn(
            "flex items-center justify-center rounded-full border-4 p-1.5",
            colorClass.iconClassName,
          )}
        >
          {icon}
        </div>
        <div className="flex flex-col">
          <div
            className={cn("text-sm font-semibold", colorClass.textClassName)}
          >
            {title}
          </div>
          {subtitle && (
            <div className="text-xs font-medium text-gray-500 dark:text-gray-400">
              {subtitle}
            </div>
          )}
        </div>
      </div>
      {actionButton && (
        <div className="flex items-center">
          <Button
            className="gap-1"
            intent="transparent"
            size="small"
            onClick={async () => await actionButton.onClick()}
          >
            {actionButton.icon}
            <div className="dark:text-gray-25 text-sm font-semibold text-gray-950">
              {actionButton.label}
            </div>
          </Button>
        </div>
      )}
    </div>
  );
};
